import { Navigate, Outlet } from 'react-router-dom';

import { useAuthContext } from '@/features/auth/context/AuthContext';

// APP_ADMIN nema organisation_id — org-scoped ekrani (ponude, ugovori,
// fakture, cjenici, ...) za njega ionako uvijek padaju na 403 na backendu.
// Umjesto praznog/pokvarenog ekrana, odmah ga vrati na njegov jedini
// upotrebljivi dio aplikacije.
export const OrgScopedRoute = () => {
  const { user } = useAuthContext();
  if (user?.role === 'APP_ADMIN') {
    return <Navigate to="/admin" replace />;
  }
  return <Outlet />;
};

// Suprotan smjer — /admin/* je rezerviran za APP_ADMIN. Svaki drugi
// autenticirani korisnik (uklj. ORGANISATION_ADMIN) koji ručno otvori URL
// vraća se na svoj dashboard.
export const AppAdminRoute = () => {
  const { user } = useAuthContext();
  if (user?.role !== 'APP_ADMIN') {
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
};
